import valuation from 'config/local/Widgets/valuation';

/**
 * @param {string} [agentId]
 * @returns {string}
 */
export function getAgentWidgetScript(agentId) {
	if (!agentId) {
		return '';
	}

	const widgetURL = new URL(valuation.urls.script);

	const script = document.createElement('script');
	script.setAttribute('src', widgetURL.toString());
	script.setAttribute('type', valuation.scriptType);

	const div = document.createElement('div');
	div.setAttribute('data-agent', agentId);
	div.setAttribute('data-tenant', valuation.dataAttributes.tenant);
	div.setAttribute('id', 'hk-widget-valuation');

	return `${script.outerHTML}\n${div.outerHTML}`;
}

/**
 * @param {string} [agentId]
 * @returns {string}
 */
export function getAgentIframe(agentId) {
	if (!agentId) {
		return '';
	}

	const widgetURL = new URL(valuation.urls.base);
	const height = '650';

	widgetURL.searchParams.append('id', agentId);

	widgetURL.searchParams.append('tenant', valuation.dataAttributes.tenant);

	const iframe = document.createElement('iframe');
	iframe.setAttribute('height', height);
	iframe.setAttribute('src', widgetURL.toString());
	iframe.setAttribute('width', '100%');
	iframe.setAttribute(
		'style',
		`border:none; height: ${height}px; width: 100%`
	);

	return iframe.outerHTML.replace(/&amp;/g, '&');
}
